import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import FlatPagination from 'material-ui-flat-pagination';
import { withAlert } from 'react-alert';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as moment from 'moment';
import loader from '../../../images/Spin-1s-107px.gif';
import {
  getAllSettlement,
  getSettlementListByAffiliateType,
  getEnrolledListByAffiliateId,
  getAllFilteredSettlement,
  getAllReferredUserByAffiliateId,
  requestDismissSettlement,
} from '../../../Actions/actions';
// let userid = localStorage.getItem("userId");
const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;


class ActivityLogView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      a: [],
      b: [],
      offset: 0,
      total: '',
      searcht: '',
      sort: 0,
      isLoader: false,
      recursive: false,
      userid: localStorage.getItem('userId'),
    };
    this.onChange = this.onChange.bind(this);
    this.getStateData = this.getStateData.bind(this);
    this.TheLayerUpAnswerstoQuestions = this.TheLayerUpAnswerstoQuestions.bind(this);
  }

  TheLayerUpAnswerstoQuestions(data) {
    this.props.answerToQuestionAction(data);
  }

  onChange() {
    this.setState({ isLoader: true });
    this.setState({ offset: 0 });
    // this.props.getEnrolledListByAffiliateId({"settlementId":0,"pageNumber":0,"pageSize":5,"searchKeyword":"",'userId': this.state.userid});

    this.props.getEnrolledListByAffiliateId({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: this.state.searcht,
      settlementId: this.state.sort,
      userId: this.state.userid,
    });
  }

    timer = null

    handleChange = (e) => {
      clearTimeout(this.timer);

      this.setState({ searcht: e.target.value });

      this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
    }

    componentDidMount() {
      if (this.props.settlementIdE !== undefined) {
        this.setState({
          sort: parseInt(this.props.settlementIdE, 10),
        });
      }
    }

    handleKeyDown = (e) => {
      if (e.keyCode === ENTER_KEY) {
        clearTimeout(this.timer);
        this.triggerChange();
      }
    }

    triggerChange = (e) => {
      this.onChange(e);
    }


    handleClick(offset) {
      this.setState({ isLoader: true });
      this.setState({ offset });
      const pageNumber = offset / 5;

      this.props.getEnrolledListByAffiliateId({
        pageNumber,
        pageSize: 5,
        searchKeyword: this.state.searcht,
        userId: this.state.userid,
        settlementId: this.state.sort,
      });
    }

    componentWillMount() {
      this.props.getSettlementListByAffiliateType({
        pageNumber: 0,
        pageSize: 100,
        searchKeyword: '',
        affiliateType: 'Business-User',
        userId: this.state.userid,
      });
    }

    componentWillReceiveProps(nextProps) {
      const getActivityLogData = nextProps.getActivityLogData ? nextProps.getActivityLogData : {};
      this.setState({ b: getActivityLogData });
      if (getActivityLogData !== 'undefined') {
        this.setState({ total: getActivityLogData.length });
      }

      const confrimSettlement = nextProps.data.receiveDismissSettlement;
      if (typeof confrimSettlement !== 'undefined') {
        if (confrimSettlement.code === 200) {
          const offset = this.state.offset;
          const pageNumber = offset / 5;
          if (this.state.recursive === true) {
            this.props.getAllReferredUserByAffiliateId({
              pageNumber,
              pageSize: 5,
              searchKeyword: '',
              catgoryId: '',
              sortBy: '',
              userId: this.state.userid,

            });
            this.setState({ recursive: false });
          }
        }
      }
      this.setState({ isLoader: false });
    }

    getStateData() {
      this.setState({ recursive: true });
    }

    render() {
      const {
        a, b, isLoader,
      } = this.state;
      const { settlementDataAffiliate } = this.props.data;

      let options = [];
      if (a.code === 400) {
        options = [];
      } else if (a !== undefined) {
        a.map(item => options.push({ value: item.categoryId, label: item.name, name: item.name }));
      }


      const sortArray = [];
      sortArray.push({ value: 0, label: 'Settlements Name', name: 'Settlements Name' });

      if (settlementDataAffiliate.records !== undefined) {
        settlementDataAffiliate.records.map(item => sortArray.push({ value: item.id, label: item.name, name: item.name }));
      }


      const allSettlementDataweHtml = [];
      if (a.code === 400) {
        options = [];
      } else if (b !== 'undefined') {
        if (Object.keys(b).length > 0 && b.code !== 400) {
          b.map((item, index) => {
            allSettlementDataweHtml.push(
              <span key={`s${index}`}>

                <div className="vehicle-fields enrollment-view-list enrollment-settlements-list2">

                  <div className="form-type">

                    <p>
                      {' '}
                      {moment(item.createdAt).format('MM-DD-YYYY')}
                    </p>
                  </div>
                  <div className="form-created">
                    <p>{item.activityName}</p>
                  </div>

                </div>


              </span>,
            );
            return true;
          });
        }
      }
      let loader1;
      if (isLoader) {
        loader1 = (
          <div className="loader">
            <img src={loader} alt="" />
          </div>
        );
      }
      return (
        <span>
          {loader1}
          <div className="section-content dashboard">
            <div className="row">

              <div className="dashboard-tabs">
                <div className="row ">

                  <div className="">
                    <div className="section-content partner-dashboard partner-referral">
                      <div className="row">
                        <div className="col s12 referral-hdr">
                          <h4 className="col s12 m9">Activity Log</h4>
                        </div>
                        <div id="AllSettlemnet" className="referral-data col s12 tab-data active allstatement-data">
                          <div className="col s12">
                            <div className="settlement-grid">
                              <div className="settlement-grid-inner">
                                <div className="grid-outer div-full">
                                  {(allSettlementDataweHtml.length > 0) ? (
                                    <ul>
                                      <div className="affiliateType-header enrollment-view-list enrollment-settlements-heading">
                                        <div className="form-type">
                                          <div>
                               Date and Time
                                          </div>
                                        </div>
                                        <div className="form-created">
                                          <div>
                               Activity Name
                                          </div>
                                        </div>

                                      </div>


                                      {allSettlementDataweHtml}
                                      <MuiThemeProvider>
                                        <FlatPagination
                                          offset={this.state.offset}
                                          limit={5}
                                          total={this.state.total}
                                          onClick={(e, offset) => this.handleClick(offset)}
                                        />
                                      </MuiThemeProvider>
                                    </ul>
                                  ) : (
                                    <ul>
                                      <li>No data available.</li>
                                    </ul>
                                  )}

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </span>
      );
    }
}

ActivityLogView.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    getAllSettlement,
    getEnrolledListByAffiliateId,
    getAllFilteredSettlement,
    getSettlementListByAffiliateType,
    getAllReferredUserByAffiliateId,
    requestDismissSettlement,
  }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(ActivityLogView));
